import { PageWrapper } from "../PageWrapper";
import {
  LightBlueDesktop,
  NaturalBlueDesktop,
  DarkBlueDesktop,
  LightBlueMobile,
  NaturalBlueMobile,
  DarkBlueMobile,
} from "../Icons";
import { ListCheckmark } from "../ListCheckmark";
import s from "./style.module.scss";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

interface TimelineSectionProps {
  period_numeric_value: string;
  tr_period_label: string;
  tr_period_title: string;
  period_checklist: TimelinePeriodChecklist[];
}

interface TimelinePeriodChecklist {
  tr_text: string;
}

export const TimelineSection = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const timelineSection = sections?.pp_v7_timeline_section;
  const productImage =
    timelineSection?.product_image ||
    `${window.template_root}/v1/pillInHand.jpg`;
  const imageNote = timelineSection?.tr_image_note;
  const timeline = timelineSection?.timeline_periods;

  const getTimelineIcons = (index: number) => {
    switch (index) {
      case 0:
        return {
          desktop: (
            <LightBlueDesktop
              className={s.timelineSection__desktop}
              accent1={timelineSection.color_first_step_bg}
              accent2={timelineSection.color_second_step_bg}
            />
          ),
          mobile: (
            <LightBlueMobile
              className={s.timelineSection__mobile}
              accent1={timelineSection.color_first_step_bg}
              accent2={timelineSection.color_second_step_bg}
            />
          ),
          colorClass: s.timelineSection__lightBlue,
        };
      case 1:
        return {
          desktop: (
            <NaturalBlueDesktop
              className={s.timelineSection__desktop}
              accent1={timelineSection.color_second_step_bg}
              accent2={timelineSection.color_third_step_bg}
            />
          ),
          mobile: (
            <NaturalBlueMobile
              className={s.timelineSection__mobile}
              accent1={timelineSection.color_second_step_bg}
              accent2={timelineSection.color_third_step_bg}
            />
          ),
          colorClass: s.timelineSection__naturalBlue,
        };
      case 2:
      default:
        return {
          desktop: (
            <DarkBlueDesktop
              className={s.timelineSection__desktop}
              accent1={timelineSection.color_third_step_bg}
            />
          ),
          mobile: (
            <DarkBlueMobile
              className={s.timelineSection__mobile}
              accent1={timelineSection.color_third_step_bg}
            />
          ),
          colorClass: s.timelineSection__darkBlue,
        };
    }
  };

  return (
    <PageWrapper>
      <div className={s.timelineSection}>
        <div className={s.timelineSection__left}>
          <img
            src={glideImage(productImage, { w: 552, h: 552 })}
            width={552}
            height={552}
            alt={brandName}
          />
          <p
            className={s.timelineSection__note}
            dangerouslySetInnerHTML={{ __html: imageNote }}
          />
        </div>
        {!!timeline && timeline.length > 0 && (
          <div className={s.timelineSection__right}>
            {timeline.map((period: TimelineSectionProps, index: number) => {
              const { desktop, mobile, colorClass } = getTimelineIcons(index);
              return (
                <div className={s.timelineSection__period} key={index}>
                  <div className={`${s.timelineSection__weeks} ${colorClass}`}>
                    <span>{period.period_numeric_value}</span>
                    <span>{period.tr_period_label}</span>
                  </div>
                  {desktop}
                  {mobile}
                  <div className={s.timelineSection__supportFor}>
                    <span>{period.tr_period_title}</span>
                    <ul>
                      {period.period_checklist &&
                        period.period_checklist.map(
                          (
                            item: TimelinePeriodChecklist,
                            checkIndex: number
                          ) => (
                            <ListCheckmark
                              dangerousHTML={item.tr_text}
                              key={checkIndex}
                            ></ListCheckmark>
                          )
                        )}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </PageWrapper>
  );
};
